import Notifications from "@/components/NotificationPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./pages/Components/SidebarPlugin";
import VueMaterial from "vue-material";
import "./assets/css/global.css";
import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";
import "es6-promise/auto";
const DashboardPlugin = {
    install(Vue) {
        Vue.use(GlobalComponents);
        Vue.use(GlobalDirectives);
        Vue.use(VueMaterial);
        Vue.use(SideBar);
        Vue.use(Notifications);
    },
};
export default DashboardPlugin;
